var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length)?_c('p',[_c('b',[_vm._v("Please correct the following error(s):")]),_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,staticClass:"text-danger"},[_c('em',[_vm._v("* "+_vm._s(error))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }